define(["libraries/jquery/jquery.select-to-autocomplete", "libraries/purify.min"], function (s, DOMPurify) {

    var AddressSearch = {

        // Set by AddressSearch.config()
        elements: {},
        urls: {},
        messages: {},
        prompts: {},
        settings: {},
        timeout: null,
        // Set by AddressSearch.getEnginesAndDatasets()
        engines: {},
        datasets: {},
        layouts: {},
        verificationDatasets: {},
        singlelineDatasets: {},
        intuitiveDatasets: {},
        addressValidateDatasets: {},

        config: function (elements, urls, messages, prompts, settings, labels, timeout) {
            AddressSearch.elements = elements;
            AddressSearch.urls = urls;
            AddressSearch.messages = messages;
            AddressSearch.prompts = prompts;
            AddressSearch.settings = settings;
            AddressSearch.labels = labels;
            AddressSearch.timeout = timeout;

            $(function () {
                $("#" + AddressSearch.elements.containerId).inView(AddressSearch.init);
            });
        },

        init: function () {
            // Populate the list of search engines and the dropdown of countries after we get the geolocation
            Utilities.geolocation.runAfter(function () {
                AddressSearch.getEnginesAndDatasets();
            }); 

            // Retry button
            $(document.body).on("click", "#" + AddressSearch.elements.retryBtnId, function () {
                AddressSearch.toggleLoading();
                AddressSearch.toggleState();
                AddressSearch.reset();
                AddressSearch.toggleLoading();
            });

            // Slide up address picklist
            $(document.body).on("click", function () {
                if ($("#" + AddressSearch.elements.searchResultsId).length > 0) {
                    $("#" + AddressSearch.elements.searchResultsId).hide();
                    $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("results refined");
                    AddressSearch.search.searchMoniker = null;
                    AddressSearch.setSearchPrompt();
                    AddressSearch.search.lastSearch = "";
                }
            });

            // Search field keyup listeners
            $(document.body).on("keyup", "#" + AddressSearch.elements.searchFieldId, function (event) {
                AddressSearch.search.keyup(event);
            });

            $(document.body).on("keyup change", "#" + AddressSearch.elements.searchFieldDualFirstId + ",#" + AddressSearch.elements.searchFieldDualSecondId, function (event) {
                $("#" + AddressSearch.elements.searchFieldId).val(
                    $("#" + AddressSearch.elements.searchFieldDualFirstId).val() + "|" + $("#" + AddressSearch.elements.searchFieldDualSecondId).val()
                );
                AddressSearch.search.keyup(event);
            });

            $(document.body).on("keyup change", "#" + AddressSearch.elements.staticSearchFieldId, function (event) {
                $("#" + AddressSearch.elements.searchFieldId).val($("#" + AddressSearch.elements.staticSearchFieldId).val());
                AddressSearch.search.keyup(event);
            });

            // Search field focus listeners
            $("#" + AddressSearch.elements.searchFieldWrapperId + ",#" + AddressSearch.elements.searchFieldWrapperId + " input")
                .on("focus", function () {
                    $("#" + AddressSearch.elements.searchFieldWrapperId).addClass("focus");
                    $("#" + AddressSearch.elements.switchModeId).addClass("focus");
                })
                .on("blur", function () {
                    $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("focus");
                    $("#" + AddressSearch.elements.switchModeId).removeClass("focus");
                });

            // Search button listener
            $("#" + AddressSearch.elements.searchFieldWrapperId + " .address-search-button-arrow")
                .on("click", function () {
                    AddressSearch.search.keyup({
                        keyCode: 13
                    }); // Spoof an Enter keypress when the button is clicked
                });

            // Prevent the form being submitted
            $("#" + AddressSearch.elements.addressSearchContainerId + " form").on("submit", function (event) {
                event.preventDefault();
                event.stopImmediatePropagation();

                // For verification datasets only, invoke a verification search upon submission
                if (AddressSearch.search.mode === AddressSearch.engines.verification) {
                    var inputVals = [];
                    $("#address-layout").find("input").each(function (index) {
                        if (this.value !== "") {
                            inputVals.push(this.value);
                        }
                    });
                    AddressSearch.search.currentSearch = inputVals.join("|");
                    AddressSearch.search.verificationSearch();
                }
            });

            // Slide down address picklist
            $(document.body).on("focus", "#" + AddressSearch.elements.searchFieldId, function (event) {
                event.stopPropagation();
                if ($("#" + AddressSearch.elements.searchResultsId + "a").length > 0) {
                    $("#" + AddressSearch.elements.searchResultsId).show().scrollTop(0);
                    $("#" + AddressSearch.elements.searchFieldWrapperId).addClass("results");
                }
            });

            // Address picklist keyup listener
            $(document.body).on("keyup", "#" + AddressSearch.elements.containerId, function (event) {
                AddressSearch.picklist.keyup(event);
            });

            // Switch mode link
            $("#" + AddressSearch.elements.switchModeId + " a").on("click", function () {
                // Flip the engines
                if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    AddressSearch.search.mode = AddressSearch.engines.addressvalidate;
                } else {
                    AddressSearch.search.mode = AddressSearch.engines.singleline;
                }
                AddressSearch.setInputMode();
                AddressSearch.rateLimit.setInitial();
            });

            // Click on the single input when in dual input mode
            $("#" + AddressSearch.elements.searchFieldId).on("click", function () {
                if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    $("#" + AddressSearch.elements.searchResultsId + " a").first().click();
                }
            });

            // Location based searching mode (USA dataset only)
            $("#" + AddressSearch.elements.locationBasedSearchingCheckboxId).on("click", function () {
                if ($("#" + AddressSearch.elements.locationBasedSearchingCheckboxId).is(":checked")) {
                    if ("geolocation" in navigator) {
                        /* geolocation is available */
                        function geoSuccessCallback(position) {
                            AddressSearch.settings.location = position.coords.latitude + "," + position.coords.longitude;
                        }
                        function geoErrorCallback(error) {
                            AddressSearch.settings.location = "";
                            $("#" + AddressSearch.elements.locationBasedSearchingCheckboxId).prop("checked", false).prop("disabled", true);
                            $("#geoError").html("Location request blocked");
                        }
                        navigator.geolocation.getCurrentPosition(geoSuccessCallback, geoErrorCallback);
                    } else {
                        /* geolocation IS NOT available */
                        $("#" + AddressSearch.elements.locationBasedSearchingCheckboxId).prop("checked", false).prop("disabled", true);
                        $("#geoError").html("Location unavailable");
                    }
                } else {
                    AddressSearch.settings.location = "";
                }
            });

        },

        getEnginesAndDatasets: function () {
                        $.ajax({
                type: "POST",
                url: AddressSearch.urls.getSupportedEngines,
                                success: function (result) {

                    var datasetCodes = [],
                        datasetNames = [],
                        isNotDuplicateCode = function (dataset) {
                            var position = $.inArray(dataset.DataSetCode, datasetCodes);
                            datasetCodes.push(dataset.DataSetCode);
                            return position < 0;
                        },
                        dupeNamePosition = function (dataset) {
                            var position = $.inArray(dataset.name, datasetNames);
                            datasetNames.push(dataset.name);
                            return position;
                        };

                    $.each(result, function (i) {
                        var engine = result[i].Name.toLowerCase(),
                            datasets = result[i].DataSets,
                            dataset;
                        
                        // Populate engine object
                        AddressSearch.engines[engine] = engine;

                        $.each(datasets, function (j) {

                            // Populate datasets object
                            dataset = datasets[j];
                            if (isNotDuplicateCode(dataset)) {
                                AddressSearch.datasets[dataset.DataSetCode] = {
                                    engine: engine,
                                    datasetCode: dataset.DataSetCode,
                                    isoCode: dataset.IsoCode,
                                    name: dataset.Name,
                                    layout: dataset.Layout,
                                    alternativeSpellings: dataset.AlternativeSpellings,
                                    relevancyBooster: dataset.RelevancyBooster
                                };
                            } 
                            else {
                                // Use SOAP API for specific datasets
                                if (dataset.UseSoapAddressValidateDemo === true) {
                                        AddressSearch.datasets[dataset.DataSetCode] = {
                                        engine: engine,
                                        datasetCode: dataset.DataSetCode,
                                        isoCode: dataset.IsoCode,
                                        name: dataset.Name,
                                        layout: dataset.Layout,
                                        alternativeSpellings: dataset.AlternativeSpellings,
                                        relevancyBooster: dataset.RelevancyBooster,
                                    };
                                }       
                            }
                            
                            // Populate the layouts object using the DataSetCode as the key
                            AddressSearch.layouts[dataset.DataSetCode] = dataset.Layout;

                            // Populate object containing all verification-friendly datasets
                            if (engine === "verification") {
                                                                AddressSearch.verificationDatasets[dataset.Name] = {
                                    "DataSetCode": dataset.DataSetCode,
                                    "IsoCode": dataset.IsoCode,
                                    "Layout": dataset.Layout
                                };
                            }
                            else if (engine === "singleline") {
                                                                AddressSearch.singlelineDatasets[dataset.Name] = {
                                    "DataSetCode": dataset.DataSetCode,
                                    "IsoCode": dataset.IsoCode,
                                    "Layout": dataset.Layout
                                };
                            }
                            else if (engine === "intuitive") {
                                                                AddressSearch.intuitiveDatasets[dataset.Name] = {
                                    "DataSetCode": dataset.DataSetCode,
                                    "IsoCode": dataset.IsoCode,
                                    "Layout": dataset.Layout
                                };
                            }
                            else if (engine === "addressvalidate") {
                                   AddressSearch.addressValidateDatasets[dataset.Name] = {
                                    "DataSetCode": dataset.DataSetCode,
                                    "IsoCode": dataset.IsoCode,
                                    "Layout": dataset.Layout
                                };
                            }

                            // Set the default country based on geolocation, if appropriate
                            if (AddressSearch.settings.useGeolocation && datasets[j].IsoCode === Utilities.geolocation.current) {
                                AddressSearch.settings.defaultDataSet = datasets[j].DataSetCode;
                            }
                        });
                    });

                    // Sort the datasets object by country name
                    var sortedCountries = [];
                    $.each(AddressSearch.datasets, function () {
                        if (dupeNamePosition(this) < 0) {
                            sortedCountries.push(this);
                        }
                        else if (this.datasetCode === AddressSearch.settings.defaultDataSet) {
                            sortedCountries.splice(dupeNamePosition(this), 1, this);
                        }
                    });
                    sortedCountries.sort(Utilities.sortData("name"));

                    // Populate the Country dropdown box
                    $.each(sortedCountries, function (i) {
                        $("#" + AddressSearch.elements.countryFieldId).append(
                            $("<option/>", {
                                "value": sortedCountries[i].datasetCode,
                                "data-iso": sortedCountries[i].isoCode,
                                "data-alternative-spellings": sortedCountries[i].alternativeSpellings,
                                "data-relevancy-booster": sortedCountries[i].relevancyBooster,
                                text: Utilities.unescapeHtml(sortedCountries[i].name)
                            })
                        );
                    });

                    // Update the fancy dropdown to contain the dynamically-loaded countries
                    // $("#" + AddressSearch.elements.countryFieldId).siblings(".dropdown").not(".address-input").remove();
                    // Select the geolocation default country, or the default country set by the content editor
                    $("#" + AddressSearch.elements.countryFieldId).val(AddressSearch.settings.defaultDataSet);

                    // Init the autocomplete country field
                    $("#" + AddressSearch.elements.countryFieldId).selectToAutocomplete();
                    $('input[data-autocomplete-id*=address-country-autocomplete]').attr('autocomplete', 'no');
                    // Initiate a "zero" search to open list                    
                    $(".country-list-autocomplete").on("focus", function () {
                        $(this).autocomplete();
                        $(this).autocomplete("search", "");
                    });

                    if (AddressSearch.search.enabled) {
                        window.createDropdown($("#" + AddressSearch.elements.countryFieldId));
                    }

                    // If default dataset is USA, feature is enabled and geolocation is available then show location specific searching checkbox
                    if (AddressSearch.settings.defaultDataSet === "USA" && AddressSearch.settings.showLocationBasedSearching && "geolocation" in navigator) {
                        $("#" + AddressSearch.elements.locationBasedSearchingContainerId).removeClass("hidden");
                    }

                    // Set initial search options
                    AddressSearch.setSearchOptions(/* Apply focus */false);

                    // Get and set rate limit for this user
                    AddressSearch.rateLimit.setInitial();

                    // Allow interaction
                    AddressSearch.toggleLoading();

                    // Bind country change to focus on search field
                    $("#" + AddressSearch.elements.countryFieldId).on("change", AddressSearch.dataSetChanged);
                },
                error: function (jqXHR) {
                    AddressSearch.search.handleError({
                        statusText: "Could not retrieve search engines and datsets",
                        status: jqXHR.status
                    });
                },
                dataType: "json",
                timeout: AddressSearch.timeout
            });
        },

        setSearchOptions: function (applyFocus) {

            // Set the current dataset
            if ($("#" + AddressSearch.elements.countryFieldId).val() !== null) {
                AddressSearch.search.currentDataSet = $("#" + AddressSearch.elements.countryFieldId).val();
            }
            else {
                AddressSearch.search.currentDataSet = $("#" + AddressSearch.elements.countryFieldId).find("option").first().attr("value");
            }

            // Set the search mode (engine)
            AddressSearch.search.mode = AddressSearch.datasets[AddressSearch.search.currentDataSet].engine;
            $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);

            // Set the search prompt
            AddressSearch.setSearchPrompt();

            // Set the input mode (single input or dual input)
            AddressSearch.setInputMode(applyFocus);
        },

        setSearchPrompt: function () {
            function isRefinementSearch() {
                return $("#" + AddressSearch.elements.searchFieldWrapperId).hasClass("refined");
            }
            function isInitialSearch() {
                return !($("#" + AddressSearch.elements.searchFieldWrapperId).hasClass("results"));
            }
            function clearSearch() {
                $("#" + AddressSearch.elements.searchFieldDualFirstId).val("");
                $("#" + AddressSearch.elements.searchFieldDualSecondId).val("");
                $("#" + AddressSearch.elements.searchFieldId).val("");
                $("#" + AddressSearch.elements.staticSearchFieldId).val("");
                $("#" + AddressSearch.elements.searchFieldId).focus();
            }
            function setPrompt(prompt) {
                $("#" + AddressSearch.elements.searchFieldId).attr("placeholder", prompt);
            }

            var promptText;

            if (!Utilities.isNullOrEmpty(AddressSearch.engines) && AddressSearch.search.mode === AddressSearch.engines.intuitive) {
                promptText = AddressSearch.prompts.intuitiveInitial;
            }
            else if (!Utilities.isNullOrEmpty(AddressSearch.engines) && AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {
                promptText = AddressSearch.prompts.addressValidateInitial;
            }
            else {
                if (isRefinementSearch()) {
                    clearSearch();
                    promptText = AddressSearch.prompts.singlelineFinal;
                }
                else if (isInitialSearch()) {
                    promptText = AddressSearch.prompts.singlelineInitial;
                }
                else {
                    clearSearch();
                    promptText = AddressSearch.prompts.singlelineMore;
                }
            }

            setPrompt(promptText);
        },

        setInputMode: function (applyFocus) {
                var setInput = {
                    typedown: function () {
                        $(".single-input").removeClass("hidden");
                        $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);
                        $("#" + AddressSearch.elements.containerId).removeAttr("data-inputmode");

                        if (applyFocus !== false) {
                            setTimeout(function () {
                                $("#" + AddressSearch.elements.searchFieldId).focus();
                            }, 0);
                        }
                    },
                    single: function () {
                        $(".single-input-static").removeClass("hidden");
                        $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);
                        $("#" + AddressSearch.elements.containerId).attr("data-inputmode", "single");

                        if (applyFocus !== false) {
                            setTimeout(function () {
                                $("#" + AddressSearch.elements.staticSearchFieldId).focus();
                            }, 0);
                        }
                    },
                    dual: function () {
                        $(".dual-input").removeClass("hidden");
                        $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);
                        $("#" + AddressSearch.elements.containerId).attr("data-inputmode", "dual");

                        if (applyFocus !== false) {
                            setTimeout(function () {
                                $("#" + AddressSearch.elements.searchFieldDualFirstId).focus();
                            }, 0);
                        }
                    },
                    verification: function () {
                        $("#address-layout").removeClass("hidden");
                        $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);
                        $("#" + AddressSearch.elements.containerId).attr("data-inputmode", "verification");

                        if (applyFocus !== false) {
                            setTimeout(function () {
                                $("#address-layout input:first").focus();
                                $("#" + AddressSearch.elements.containerId).attr("data-searchmode", AddressSearch.search.mode);
                                $("#" + AddressSearch.elements.containerId).attr("data-inputmode", "verification");
                            }, 0);
                        }
                    }
                };

            $("#address-layout").addClass("hidden");

            // Special case: If GBR then show a button to switch between single/multi mode
            if (AddressSearch.search.currentDataSet === "GBR") {
                // If engine is singleline, show dual input for house number/postcode
                if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    setInput.dual();
                    $("#" + AddressSearch.elements.switchModeId + " a").text(AddressSearch.messages.modeSingleLine);
                }
                else {
                    // Else set a single input for typedown
                    setInput.typedown();
                    $("#" + AddressSearch.elements.switchModeId + " a").text(AddressSearch.messages.modeVerification);
                }
                $("#" + AddressSearch.elements.switchModeId).fadeIn("fast");
            }
            else {
                // if verification engine, show multiple inputs
                if (AddressSearch.search.mode === AddressSearch.engines.verification) {
                    setInput.verification();
                }
                // else if singleline engine, show single input
                else if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    setInput.single();
                }
                // else, show typedown
                else {
                    setInput.typedown();
                }
                $("#" + AddressSearch.elements.switchModeId).fadeOut("fast");
            }
        },

        rateLimit: {

            lastLimitReason: "",
            timerId: 0,

            setInitial: function () {
                // Determine what rate limit URL to check based on the searching engine
                var rateLimitUrl = (AddressSearch.search.mode === AddressSearch.engines.addressvalidate) ? AddressSearch.urls.addressValidateRateLimit : AddressSearch.urls.getRateLimit;
                $.ajax({
                    type: "POST",
                    url: rateLimitUrl,
                    success: function (result) {
                        // Unfortunately the engines return these variables with diff. casing!
                        var rateLimit = result.RateLimit || result.rateLimit;
                        var limitReason = result.LimitReason || result.limitReason;
                        AddressSearch.rateLimit.update(rateLimit, limitReason);
                    },
                    error: function (jqXHR, textStatus) {
                        AddressSearch.search.handleError({
                            statusText: textStatus,
                            status: jqXHR.status
                        });
                    },
                    dataType: "json",
                    timeout: AddressSearch.timeout
                });
            },

            update: function (rateLimit, limitReason) {
                var limitMessage, limitReasonText;

                // Let internal users continue to search if IP blocking is the limitReason
                if (limitReason === "InternalIP") {
                    rateLimit = 10;
                    limitReasonText = "(Internal IP address)";
                } else if (limitReason === "StaffRole") {
                    rateLimit = 10;
                    limitReasonText = "(Staff access)";
                } else if (limitReason === "ThrottleLimitReached") {
                    limitReasonText = AddressSearch.messages.throttleLimitReached;
                    // Disable searching and highlight warning
                    AddressSearch.search.throttle();
                }

                if (rateLimit > 1) {
                    limitMessage = AddressSearch.messages.searchCountMultiple.replace("{}", rateLimit);
                }
                else if (rateLimit === 1) {
                    limitMessage = AddressSearch.messages.searchCountSingle;
                }
                else {
                    limitMessage = AddressSearch.messages.searchCountNone;
                    // Add messages to the limit string for particular reasons
                    switch (limitReason) {
                        case "IPDailyLimit":
                            limitReasonText = AddressSearch.messages.ipDailyBlock;
                            break;
                        case "IPMonthlyLimit":
                            limitReasonText = AddressSearch.messages.ipMonthlyBlock;
                            break;
                        case "IPBlocked":
                            limitReasonText = AddressSearch.messages.ipPermanentBlock;
                            break;
                        case "ThrottleLimitReached":
                            limitReasonText = AddressSearch.messages.throttleLimitReached;
                            break;
                    }
                    // Disable searching and highlight warning if the rateLimit is less than 1
                    AddressSearch.search.disable.permanent();
                }

                // Update the "searches remaining" text
                if (typeof limitReasonText !== "undefined") {
                    limitMessage += "<br />" + Utilities.escapeHtml(limitReasonText);
                }
                $("." + AddressSearch.elements.rateLimitMessageClass).html(limitMessage);
                AddressSearch.search.enable();
                AddressSearch.search.toggleThinkingSpinner("hide");
                AddressSearch.rateLimit.lastLimitReason = limitReason;
                AddressSearch.rateLimit.pollThrottleLimitReached();
            },

            pollThrottleLimitReached: function() {
                if (AddressSearch.rateLimit.lastLimitReason !== "ThrottleLimitReached") {
                    return;
                }
                if (AddressSearch.rateLimit.timerId !== 0) {
                    clearInterval(AddressSearch.rateLimit.timerId);
                }
                AddressSearch.rateLimit.timerId = setInterval(function() {
                    $.ajax({
                        url: AddressSearch.urls.addressValidateRateLimit,
                        type: "POST",
                        success: function (data) {
                            AddressSearch.reset();
                            AddressSearch.setInputMode();
                            AddressSearch.rateLimit.update(data.RateLimit, data.LimitReason);
                            if (data.LimitReason !== "ThrottleLimitReached") {
                                clearInterval(AddressSearch.rateLimit.timerId);
                                AddressSearch.rateLimit.timerId = 0;
                            }
                        },
                        dataType: "json",
                        timeout: AddressSearch.timeout
                    });
                }, 5000);
            }
        },

        toggleState: function () {
            $("." + AddressSearch.elements.stateClass).toggleClass("hidden");
        },

        toggleLoading: function (state) {
            $("#" + AddressSearch.elements.containerId).toggleLoaders(state);
            $("." + AddressSearch.elements.stateClass + ".toggle-visibility").removeClass("invisible");
        },

        search: {

            enabled: true,
            mode: null,
            lastMode: null,
            currentDataSet: "",
            lastDataSet: "",
            currentSearch: "",
            lastSearch: "",
            currentRequest: null,
            searchMoniker: null,

            keyup: function (event) {

                var $input = $("#" + AddressSearch.elements.searchFieldId),
                    moniker = $input.attr("data-moniker"),
                    isRange = $input.attr("data-isrange");

                AddressSearch.search.currentSearch = $input.val();

                // Quickly accept an address by pressing Enter, or trigger refinement if more details are present
                if (event.keyCode === 13) {
                    if (event.length > 1) {
                        event.preventDefault();
                    }

                    // TODO: replace this huge check with a more data-driven approach
                    if (AddressSearch.search.currentSearch.length > 0 &&
                        AddressSearch.search.mode === AddressSearch.engines.singleline &&
                        $("#" + AddressSearch.elements.searchFieldWrapperId).hasClass("results") &&
                        typeof $("#" + AddressSearch.elements.searchResultsId).find("a").attr("information") === "undefined") {

                        $("#" + AddressSearch.elements.searchFieldWrapperId).addClass("refining");
                    }
                    else if (typeof moniker !== typeof undefined && moniker !== false) {
                        if (isRange !== "true") {
                            AddressSearch.search.formatAddress(null, moniker);
                            $input.removeAttr("data-moniker");
                        }
                        else {
                            AddressSearch.search.selectFromRange($("#" + AddressSearch.elements.searchResultsId).find("a.selected"));
                        }
                    }
                }

                // Intuitive search or Address Validate
                if (AddressSearch.search.mode === AddressSearch.engines.intuitive || AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {

                    var userTimeout = 100;

                    if (AddressSearch.search.currentSearch !== null &&
                        $.trim(AddressSearch.search.currentSearch).length > 0 &&
                        (event.keyCode < 37 || event.keyCode > 40) &&
                        AddressSearch.search.currentSearch !== AddressSearch.search.lastSearch
                    ) {

                        setTimeout(
                            function () {
                                AddressSearch.search[AddressSearch.search.mode + "Search"]();
                            },
                            userTimeout);
                    }
                    else if (!AddressSearch.search.currentSearch) {
                        $("#" + AddressSearch.elements.searchResultsId).hide();
                        $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("results refined");
                        $("#" + AddressSearch.elements.searchFieldId).removeAttr("data-moniker");
                        AddressSearch.search.searchMoniker = null;
                        AddressSearch.setSearchPrompt();

                        // If the user deletes everything, allow them to do the same search again
                        AddressSearch.search.lastSearch = "";
                    }
                }

                // Single Line and Verification searches
                else if (event.keyCode === 13 && AddressSearch.search.currentSearch !== "") { // Enter
                    if (AddressSearch.search.currentSearch !== AddressSearch.search.lastSearch) {

                        // Refine an existing search, or begin a new one
                        if ($("#" + AddressSearch.elements.searchFieldWrapperId).hasClass("results") &&
                            typeof $("#" + AddressSearch.elements.searchResultsId).find("a").attr("information") === "undefined") {
                            AddressSearch.search.refine(AddressSearch.search.searchMoniker, AddressSearch.search.currentSearch);
                        }
                        else if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                            AddressSearch.search.singleLineSearch();
                        }
                        else {
                            AddressSearch.search.verificationSearch();
                        }
                    }
                }
            },

            intuitiveSearch: function () {

                if (AddressSearch.search.enabled && AddressSearch.search.currentSearch.length > 0) {

                    AddressSearch.search.toggleThinkingSpinner("show");

                    //Same search as the last one for the same dataset
                    if (AddressSearch.search.lastDataSet === AddressSearch.search.currentDataSet && AddressSearch.search.currentSearch === AddressSearch.search.lastSearch) {
                        return;
                    }

                    AddressSearch.search.lastDataSet = AddressSearch.search.currentDataSet;
                    AddressSearch.search.lastSearch = AddressSearch.search.currentSearch;

                    if (AddressSearch.search.currentRequest) {
                        AddressSearch.search.currentRequest.abort();
                        AddressSearch.search.toggleThinkingSpinner("hide");
                    }

                    AddressSearch.search.currentRequest = $.ajax({
                        type: "POST",
                        url: AddressSearch.urls.intuitiveSearch,
                        data: {
                            dataSet: AddressSearch.search.currentDataSet,
                            searchTerm: AddressSearch.search.currentSearch,
                            layout: AddressSearch.layouts[AddressSearch.search.currentDataSet]
                        },
                        success: function (result) {
                            AddressSearch.search.displayAddresses(result);
                        },
                        error: function (jqXHR, textStatus) {
                            AddressSearch.search.handleError({
                                statusText: textStatus,
                                status: jqXHR.status
                            });
                        },
                        dataType: "json",
                        timeout: AddressSearch.timeout
                    });
                }
            },

            addressvalidateSearch: function () {
                if (AddressSearch.search.enabled && AddressSearch.search.currentSearch.length > 0) {

                    //AddressSearch.search.toggleThinkingSpinner("show");

                    //Same search as the last one for the same dataset
                    if (AddressSearch.search.lastDataSet === AddressSearch.search.currentDataSet && AddressSearch.search.currentSearch === AddressSearch.search.lastSearch) {
                        return;
                    }

                    AddressSearch.search.lastDataSet = AddressSearch.search.currentDataSet;
                    AddressSearch.search.lastSearch = AddressSearch.search.currentSearch;

                    if (AddressSearch.search.currentRequest) {
                        AddressSearch.search.currentRequest.abort();
                        AddressSearch.search.toggleThinkingSpinner("hide");
                    }

                    var currentDataSet = AddressSearch.search.currentDataSet;
                    var datasetParam = "";
                    if (currentDataSet.indexOf('/') != -1) {
                        var dataSetArray = currentDataSet.split('/');
                        currentDataSet = dataSetArray[0];
                        datasetParam = dataSetArray[1];
                    }

                    var url = AddressSearch.urls.addressValidateApiBaseUrl + "search?country={0}&query={1}&from=0&take=7&auth-token={2}&location={3}&dataset={4}";
                    url = url.replace("{0}", currentDataSet);
                    url = url.replace("{1}", encodeURIComponent(AddressSearch.search.currentSearch));
                    url = url.replace("{2}", AddressSearch.settings.addressValidateToken);
                    url = url.replace("{3}", AddressSearch.settings.location);
                    url = url.replace("{4}", datasetParam);

                    var ajaxDetails = {};
                    ajaxDetails.beforeSend = $.noop;

                    ajaxDetails.type = "GET";
                    ajaxDetails.url = url;
                    ajaxDetails.success = function (result) {
                        AddressSearch.search.displayAddresses(result);
                    };
                    ajaxDetails.error = function (jqXHR, textStatus) {
                        AddressSearch.search.handleError({
                            statusText: textStatus,
                            status: jqXHR.status
                        });
                    };
                    ajaxDetails.dataType = "json";
                    ajaxDetails.timeout = AddressSearch.timeout;

                    // Inititate the search ajax request
                    AddressSearch.search.currentRequest = $.ajax(ajaxDetails);
                }
            },

            singleLineSearch: function () {

                if (AddressSearch.search.enabled) {

                    AddressSearch.search.toggleThinkingSpinner("show");

                    AddressSearch.search.lastDataSet = AddressSearch.search.currentDataSet;
                    AddressSearch.search.lastSearch = AddressSearch.search.currentSearch;

                    if (AddressSearch.search.currentRequest) {
                        AddressSearch.search.currentRequest.abort();
                    }

                    AddressSearch.search.currentRequest = $.ajax({
                        type: "POST",
                        url: AddressSearch.urls.singleLineSearch,
                        data: {
                            dataSet: AddressSearch.search.currentDataSet,
                            searchTerm: AddressSearch.search.currentSearch,
                            layout: AddressSearch.layouts[AddressSearch.search.currentDataSet]
                        },
                        success: function (result) {
                            AddressSearch.search.displayAddresses(result);
                        },
                        error: function (jqXHR, textStatus) {
                            AddressSearch.search.handleError({
                                statusText: textStatus,
                                status: jqXHR.status
                            });
                        },
                        dataType: "json",
                        timeout: AddressSearch.timeout
                    });
                }
            },

            verificationSearch: function () {

                if (AddressSearch.search.enabled && AddressSearch.search.currentSearch.length > 0) {

                    AddressSearch.search.toggleThinkingSpinner("show");

                    AddressSearch.search.lastDataSet = AddressSearch.search.currentDataSet;
                    AddressSearch.search.lastSearch = AddressSearch.search.currentSearch;

                    if (AddressSearch.search.currentRequest) {
                        AddressSearch.search.currentRequest.abort();
                    }

                    AddressSearch.search.currentRequest = $.ajax({
                        type: "POST",
                        url: AddressSearch.urls.verificationSearch,
                        data: {
                            dataSet: AddressSearch.search.currentDataSet,
                            searchTerm: AddressSearch.search.currentSearch,
                            promptSet: 4,
                            layout: AddressSearch.layouts[AddressSearch.search.currentDataSet]
                        },
                        success: function (result) {
                            AddressSearch.search.displayAddresses(result);
                        },
                        error: function (jqXHR, textStatus) {
                            AddressSearch.search.handleError({
                                statusText: textStatus,
                                status: jqXHR.status
                            });
                        },
                        dataType: "json",
                        timeout: AddressSearch.timeout
                    });
                }
            },

            convertAddressValidatePicklist: function (result) {
                var formattedResult = {};
                if (result) {
                    formattedResult.Moniker = "";
                    formattedResult.Items = [];
                    var results = result.results;
                    for (var i = 0; i < results.length; i++) {
                        var item = {};
                        item.Text = results[i].suggestion;
                        item.IsUnresolvableRange = false;
                        item.Moniker = results[i].format;
                        item.Matched = results[i].matched;
                        formattedResult.Items.push(item);
                    }
                }
                return formattedResult;
            },

            displayAddresses: function (result) {
                // Convert Address Validate response to the same as Intuitive
                if (AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {
                    result = AddressSearch.search.convertAddressValidatePicklist(result);
                }

                // If AddressLines is not null, show the final address (However for Verification, only do so if not "InteractionRequired")
                if ((!Utilities.isNullOrEmpty(result.AddressLines) && AddressSearch.search.mode !== AddressSearch.engines.verification) || (!Utilities.isNullOrEmpty(result.AddressLines) && result.VerificationLevel !== "InteractionRequired")) {
                    AddressSearch.search.showFormattedAddress(result);

                    AddressSearch.toggleState();
                    AddressSearch.rateLimit.update(result.RateLimit, result.LimitReason);
                    AddressSearch.search.webAnalytics();
                    return;
                }

                // Else, display the picklist and add functionality to enable selecting addresses
                AddressSearch.search.searchMoniker = result.Moniker;

                var picklistSelector = AddressSearch.elements.searchResultsId;
                // For Verification datasets the picklist is in the modal, so change the selector accordingly
                if (AddressSearch.search.mode === AddressSearch.engines.verification) {
                    picklistSelector = "verification-suggestions ul";
                }

                $("#" + picklistSelector).html("");
                $("#" + AddressSearch.elements.errorPanelId).addClass("hidden");

                // Automatically accept an address if it's the only one in the picklist
                if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    if (result.Items.length > 0 && (result.IsAutoFormatSafe || result.IsAutoFormatPastClose)) {
                        AddressSearch.search.formatAddress(null, result.Items[0].Moniker);
                        return;
                    }
                }

                // If the Items array comes back empty, spoof a No Matches item to trigger the informational message
                if (result.Items.length === 0) {
                    result.Items.push({
                        IsInformation: true, IsRange: false
                    });
                }

                $.each(result.Items, function (i) {

                    var item = result.Items[i],
                        $li = $("<li/>", {
                            "role": "presentation"
                        }),
                        $a = $("<a/>", {
                            "role": "menuitem", "tabindex": "-1", "href": "#",
                            "title": item.Text,
                            "data-isrange": item.IsUnresolvableRange,
                            text: item.Text
                        });

                    // Warning and informational messages
                    if (item.IsInformation || item.IsWarning || item.Text === "Continue typing") {
                        // Keep typing prompt
                        if (result.MaximumMatches || result.Prompt === "Enter selection" || result.Prompt === "Enter search" || item.Text === "Continue typing") {
                            $a.text(AddressSearch.prompts.keepTyping)
                                .attr("title", AddressSearch.prompts.keepTyping)
                                .attr("information", undefined)
                                .on("click", function (e) {
                                    e.preventDefault();
                                });
                        }
                        // No matches prompt
                        else {
                            $a.text(AddressSearch.prompts.noMatches)
                                .attr("title", AddressSearch.prompts.noMatches)
                                .attr("information", undefined)
                                .on("click", function (e) {
                                    e.preventDefault();
                                    AddressSearch.reset();
                                });
                            $("#" + AddressSearch.elements.searchFieldDualFirstId).val("");
                            $("#" + AddressSearch.elements.searchFieldDualSecondId).val("");
                            $("#" + AddressSearch.elements.searchFieldId).attr("placeholder", "No matches");
                        }
                        AddressSearch.searchMoniker = null;
                        $("#" + AddressSearch.elements.searchFieldId).removeAttr("data-moniker");
                    }

                    // Address picklist entries
                    else {
                        $a.attr("data-moniker", DOMPurify.sanitize(item.Moniker));
                        if (!Utilities.isNullOrEmpty(item.PostalCode)) {
                            $a.text(item.Text + ", " + item.PostalCode);
                        }
                        // Add emphasis to show where in the address their search has matched
                        if (!Utilities.isNullOrEmpty(item.Matched)) {
                            var highlights = item.Matched || [], label = item.Text;

                            for (var j = 0; j < highlights.length; j++) {
                                var replacement = '<b>' + label.substring(highlights[j][0], highlights[j][1]) + '</b>';
                                label = label.substring(0, highlights[j][0]) + replacement + label.substring(highlights[j][1]);
                            }
                            // Update the html with the new label
                            $a.html(DOMPurify.sanitize(label));
                        }

                        $a.on("click", function (event) {
                            event.preventDefault();

                            // Accept a full address
                            if (!$(this).data("isrange")) {
                                AddressSearch.search.formatAddress(event, $(this).data("moniker"));
                            }
                            // Prompt for a building number to select from a range
                            else {
                                AddressSearch.search.selectFromRange($(this));
                            }
                        });
                    }

                    // For Verification, append all items regardless of if it's a range
                    if (!$a.data("isrange") || AddressSearch.search.mode === AddressSearch.engines.verification) {
                        $("#" + picklistSelector).append($li.append($a));
                    } else {
                        AddressSearch.search.filterRanges.addRange(mode, item);
                    }
                    AddressSearch.picklist.resetTabCount();
                });

                // If Verification engine and "Interaction Required", write out the suggested address
                if (AddressSearch.search.mode === AddressSearch.engines.verification && !Utilities.isNullOrEmpty(result.AddressLines) && result.VerificationLevel === "InteractionRequired") {
                    // Clear anything currently in the list
                    $("#" + picklistSelector).html("");
                    $.each(result.AddressLines, function (i) {
                        if (result.AddressLines[i].Text !== "") {
                            var $li = $("<li/>", {
                                "role": "presentation",
                                "class": "text-bold",
                                "html": result.AddressLines[i].Text
                            });
                            $("#" + picklistSelector).append($li);
                        }
                    });
                }

                // Show a modal popup for Verification
                if (AddressSearch.search.mode === AddressSearch.engines.verification) {
                    AddressSearch.search.verificationModal.display(result);
                }
                else {
                    // Show picklist and scroll into view
                    $("#" + AddressSearch.elements.searchResultsId).show().scrollTop(0);
                }

                $("#" + AddressSearch.elements.searchFieldWrapperId).addClass("results");
                AddressSearch.search.toggleThinkingSpinner("hide");
                AddressSearch.search.currentSearch = "";

                // Highlight the first address and pass the search moniker to the input field (makes Enter work)
                var $address = $("#" + AddressSearch.elements.searchResultsId).find("a").first();
                if (typeof $address.attr("information") === "undefined") {
                    $address.addClass("selected");
                    $("#" + AddressSearch.elements.searchFieldId).attr("data-moniker", $address.attr("data-moniker"));
                    $("#" + AddressSearch.elements.searchFieldId).attr("data-isrange", $address.attr("data-isrange"));
                    AddressSearch.setSearchPrompt();
                }
            },

            // Verification engine uses a modal for refinement
            verificationModal: {
                messages: {
                    "InteractionRequired": { heading1: "We think that your address may be incorrect or incomplete.", heading2: "To proceed, please choose from one of the options below.", potentialMatches: "We recommend:" },
                    "StreetPartial": { heading1: "Sorry, we do not recognize your house or building number.", heading2: "To proceed, please check and choose from one of the options below.", potentialMatches: "Show all potential matches:" },
                    "PremisesPartial": { heading1: "Sorry, we think your apartment/suite/unit is missing or wrong.", heading2: "To proceed, please enter your apartment/suite/unit or use your address as entered.", potentialMatches: "Show all potential matches:" },
                    "Multiple": { heading1: "We found more than one match for your address.", heading2: "To proceed, please choose one of the options below.", potentialMatches: "Our suggested matches:" },
                    "None": { heading1: "Sorry, we could not find a match for your address.", heading2: "To proceed, please choose one of the options below.", potentialMatches: "Our suggested matches:" }
                },
                setTextValues: function () {
                    var messages = AddressSearch.search.verificationModal.messages[AddressSearch.search.verificationModal.verificationLevel];
                    if (!Utilities.isNullOrEmpty(messages)) {
                        AddressSearch.search.verificationModal.$modal.find(".heading1").text(messages.heading1);
                        AddressSearch.search.verificationModal.$modal.find(".heading2").text(messages.heading2);
                        AddressSearch.search.verificationModal.$modal.find(".potential-matches").text(messages.potentialMatches);
                    }
                },
                handleRefinementForm: function () {
                    var $refineContainer = $("#verification-refine");
                    var $refineForm = $refineContainer.find("form").removeClass("hidden");
                    // Focus the input
                    setTimeout(function () {
                        $refineForm.find("input").val("");
                        $refineForm.find("input").focus();
                    }, 600);
                    // Call a "refine" search on submission
                    $refineForm.on("submit", function (e) {
                        e.preventDefault();
                        AddressSearch.search.refine(AddressSearch.search.searchMoniker, $(this).find("input").val());
                    });
                },
                handleUseSuggestedAddressForm: function () {
                    var $form = $("#use-suggested-address").addClass("hidden");
                    if (AddressSearch.search.verificationModal.verificationLevel === "InteractionRequired") {
                        $form.removeClass("hidden");
                    }

                    // Call a "Verify" search again on submission
                    $form.off().on("submit", function (e) {
                        e.preventDefault();
                        // Get suggested address
                        var suggestedAddress = $("#verification-suggestions li").map(function () {
                            return $(this).text();
                        }).get().join();
                        // Update the current search
                        AddressSearch.search.currentSearch = suggestedAddress;
                        AddressSearch.search.verificationSearch();
                    });
                },
                handleUseEnteredAddress: function ($originalAddressContainer, originalAddressLines) {
                    $originalAddressContainer.find("button").on("click", function () {
                        AddressSearch.search.manuallyFormatAddress(originalAddressLines);
                    });
                },
                handleSuggestionsList: function () {
                    // Show the suggestions for "Multiple" or show full suggested address for "InteractionRequired"
                    if (AddressSearch.search.verificationModal.verificationLevel === "Multiple" || AddressSearch.search.verificationModal.verificationLevel === "InteractionRequired") {
                        $("#verification-suggestions ul").removeClass("hidden");
                    }
                    // Toggle the list when necessary
                    AddressSearch.search.verificationModal.$modal.find(".potential-matches").on("click", function () {
                        $("#verification-suggestions ul").toggleClass("hidden");
                    });
                },
                display: function (result) {
                    AddressSearch.search.verificationModal.$modal = $("#verification-modal");

                    // Show their original address
                    var $originalAddressContainer = $("#verification-original-address");
                    var $originalAddressList = $originalAddressContainer.find("ul").html("");
                    var originalAddressLines = AddressSearch.search.currentSearch.split("|");

                    $.each(originalAddressLines, function (index, value) {
                        $originalAddressList.append("<li>" + value + "</li>");
                    });

                    // Store the verification level
                    AddressSearch.search.verificationModal.verificationLevel = Utilities.escapeHtml(result.VerificationLevel);
                    AddressSearch.search.verificationModal.$modal.attr("verification-level", AddressSearch.search.verificationModal.verificationLevel);

                    // Set various message texts
                    AddressSearch.search.verificationModal.setTextValues();

                    // Toggle the suggestions
                    AddressSearch.search.verificationModal.handleSuggestionsList();

                    // Handle interaction with the refinement form
                    AddressSearch.search.verificationModal.handleRefinementForm();

                    // Handle "Use suggested address" form (InteractionRequired only)
                    AddressSearch.search.verificationModal.handleUseSuggestedAddressForm();

                    // Handle the "Use address entered" option
                    AddressSearch.search.verificationModal.handleUseEnteredAddress($originalAddressContainer, originalAddressLines);

                    // Show the modal
                    AddressSearch.search.verificationModal.$modal.modal("show");
                }
            },

            // Manually format an address after the user choose "Use address entered" option (Verification only)
            manuallyFormatAddress: function (addressLines) {
                // Create a data object for use later
                var data = {
                    AddressLines: []
                };

                for (var i = 0; i < addressLines.length; i++) {
                    data.AddressLines.push({ "Text": addressLines[i] });
                }

                // Display a heading
                var $formattedAddressDiv = $("#" + AddressSearch.elements.formattedAddressId);
                $formattedAddressDiv.text("").removeClass("hidden");
                $formattedAddressDiv.html($("<h3/>", { text: "Address" }));

                // Display the address
                AddressSearch.search.printAddress(data, $formattedAddressDiv);

                // Hide any modals
                $("#verification-modal").modal("hide");

                AddressSearch.toggleState();
            },

            refine: function (moniker, refinement) {

                $.ajax({
                    type: "POST",
                    url: AddressSearch.urls.refine,
                    data: {
                        moniker: moniker,
                        refinement: refinement,
                        layout: AddressSearch.layouts[AddressSearch.search.currentDataSet]
                    },
                    success: function (result) {
                        $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("refining").addClass("refined");

                        if (result.Items.length === 1 && !result.Items[0].IsInformation && !result.Items[0].IsWarning) {
                            AddressSearch.search.formatAddress(null, result.Items[0].Moniker);
                        }
                        else {
                            AddressSearch.search.displayAddresses(result);
                        }
                    },
                    error: function (jqXHR, textStatus) {
                        AddressSearch.search.handleError({
                            statusText: textStatus,
                            status: jqXHR.status
                        });
                    },
                    dataType: "json",
                    timeout: AddressSearch.timeout
                });

            },

            convertAddressValidateFormattedResult: function (data) {
                var tempData = {
                    "AddressLines": [],
                    LimitReason: data.limitReason,
                    RateLimit: data.rateLimit || 10
                };

                if (data.address.length > 0) {
                    var address = data.address;
                    for (var i = 0; i < address.length; i++) {
                        var line = address[i];
                        // The line object will only have one property, but we don't know the key
                        for (var key in line) {
                            if (line.hasOwnProperty(key)) {
                                tempData.AddressLines.push({ Text: line[key] });
                            }
                        }
                    }
                }

                return tempData;
            },

            formatAddress: function (event, moniker) {
                if (event !== null) {
                    event.preventDefault();
                }
                
                                if (AddressSearch.search.enabled === false) {
                    return;
                }
                AddressSearch.toggleLoading("hide");

                var type = "POST";
                var url = AddressSearch.urls.addressValidateFormat;
                var data = {
                    moniker: moniker,
                    layout: AddressSearch.layouts[AddressSearch.search.currentDataSet]
                };
                var ajaxDetails = {};

                // Overwrite some settings so Address Validate can GET the format address from API
                // if (AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {
                //     type = "GET";
                //     data = {
                //         "auth-token": AddressSearch.settings.addressValidateToken
                //     };
                //     url = moniker;
                //     console.log(`url after: ${url}`);
                //     ajaxDetails.beforeSend = $.noop;
                // }

                ajaxDetails.type = type;
                ajaxDetails.url = url;
                ajaxDetails.data = data;
                ajaxDetails.success = AddressSearch.search.formatAddressSuccess;
                ajaxDetails.error = function (jqXHR, textStatus) {
                    AddressSearch.search.handleError({
                        statusText: textStatus,
                        status: jqXHR.status
                    });
                };
                ajaxDetails.dataType = "json";
                ajaxDetails.timeout = AddressSearch.timeout;
                
                if (AddressSearch.search.mode === AddressSearch.engines.addressvalidate &&
                    AddressSearch.rateLimit.lastLimitReason === "ThrottleLimitReached") {
                    AddressSearch.reset();
                    AddressSearch.setInputMode();
                } else {
                    // Initiate the format ajax request
                    $.ajax(ajaxDetails);
                }
            },

            formatAddressSuccess: function (data) {
                // Format Address Validate responses to match Intuitive
                //if (AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {
                    data = AddressSearch.search.convertAddressValidateFormattedResult(data);
                //}

                if (data.LimitReason === "ThrottleLimitReached") {
                    AddressSearch.reset();
                    AddressSearch.setInputMode();
                    AddressSearch.rateLimit.setInitial();
                    return;
                }

                AddressSearch.search.showFormattedAddress(data);

                // slide up picklist
                AddressSearch.picklist.slideUp();

                // Hide any modals
                $("#verification-modal").modal("hide");

                AddressSearch.toggleState();
                AddressSearch.search.webAnalytics();

                // Ping our server to increment the count because Address Validate goes directly to API
                if (AddressSearch.search.mode === AddressSearch.engines.addressvalidate) {
                    $.ajax({
                        url: AddressSearch.urls.incrementAddressValidateRateLimit,
                        type: "POST",
                        success: function (data) {
                            AddressSearch.rateLimit.update(data.RateLimit, data.LimitReason);
                        },
                        dataType: "json",
                        timeout: AddressSearch.timeout
                    });
                } else {
                    // Or update the rateLimit straight away based on the response
                    AddressSearch.rateLimit.update(data.RateLimit, data.LimitReason);
                }
            },

            // Print the formatted address to the page (with heading)
            showFormattedAddress: function (data) {
                var formattedAddressDiv = $("#" + AddressSearch.elements.formattedAddressId);
                formattedAddressDiv.text("").html($("<h3/>", {
                    text: AddressSearch.messages.formattedAddressHeading
                }));

                // Print address to page
                AddressSearch.search.printAddress(data, formattedAddressDiv);

                // If we appended DataPlus element, include a heading/toggle
                if (formattedAddressDiv.find(".dataplus-element").length > 0) {
                    var $first = formattedAddressDiv.find(".dataplus-element").get(0);
                    $("<h3/>", {
                        html: "Enhanced DataPlus elements: <span class='hidden'>[Show]</span><span>[Hide]</span>",
                        "class": "dataplus-heading"
                    })
                        .insertBefore($first)
                        .on("click", AddressSearch.search.toggleDataPlusElements);
                }
            },

            printAddress: function (data, formattedAddressDiv) {
                $.each(data.AddressLines, function (i) {
                    if (data.AddressLines[i].Text) {
                        // Show DataPlus elements
                        if (AddressSearch.settings.showDataPlus && data.AddressLines[i].DataPlus && data.AddressLines[i].Text) {
                            formattedAddressDiv.append($("<p/>", { "class": "dataplus-element" }).html("<label>" + Utilities.escapeHtml(data.AddressLines[i].Label) + "</label>: <span>" + Utilities.escapeHtml(data.AddressLines[i].Text) + "</span>"));
                        }
                        // Show non-DataPlus elements
                        else if (!data.AddressLines[i].DataPlus && data.AddressLines[i].Text) {
                            // Hack for Australia datasets. Append state and postal code to locality
                            if ((AddressSearch.search.currentDataSet === "AUS" || AddressSearch.search.currentDataSet === "AUE" || AddressSearch.search.currentDataSet === "AUG") &&
                                (data.AddressLines[i].Label === "State code" || data.AddressLines[i].Label === "Postcode")) {
                                formattedAddressDiv.find("p:last").append(" " + Utilities.escapeHtml(data.AddressLines[i].Text));
                            } else {
                                formattedAddressDiv.append($("<p/>").text(DOMPurify.sanitize(data.AddressLines[i].Text)));
                            }
                        }
                    }
                });
            },

            toggleDataPlusElements: function (e) {
                e.preventDefault();
                // Toggle the show/hide text on the link
                $(this).find("span").toggleClass("hidden");
                // Toggle the visibility of the elements
                $("#" + AddressSearch.elements.formattedAddressId).find(".dataplus-element").toggleClass("hidden");
            },

            selectFromRange: function ($dropdownListItem) {
                // Get list of all addresses currently in the on-screen picklist
                var $addresses = $dropdownListItem.closest("ul").find("a").not($dropdownListItem);
                // Remove unselected addresses and highlight the selected one
                $addresses.removeClass("selected")
                    .parent().slideUp("fast", function () {
                        $(this).remove();
                    });
                $dropdownListItem.addClass("selected");
                // Update the prompt
                $("#" + AddressSearch.elements.searchFieldId).addClass("error");
                setTimeout(function () {
                    $("#" + AddressSearch.elements.searchFieldId).removeClass("error");
                }, 400);
                $("#" + AddressSearch.elements.searchFieldId).attr("placeholder", AddressSearch.prompts.singlelineRange);
            },

            webAnalytics: function () {
                // Push GTM dataLayer event for successful address validation
                Utilities.trackEvent({
                    "event": "AddressValidationDemo"
                });
            },

            toggleThinkingSpinner: function (state) {
                var container = $("#" + AddressSearch.elements.searchesRemainingId);
                var existingSpinner = container.find(".loader");
                if (state === "hide" && existingSpinner.length > 0) {
                    existingSpinner.fadeToggle(function () {
                        existingSpinner.remove();
                    });
                } else if (state === "show" && existingSpinner.length < 1) {
                    var spinner = $("<div/>", {
                        "class": "loader loader-inline",
                        "style": "height: 40px"
                    })
                        .append($("<div/>", {
                            "class": "spinner",
                            "style": "top: 12px"
                        }));
                    spinner.appendTo(container);
                }
            },

            enable: function () {
                if (AddressSearch.search.enabled) {
                    $("#" + AddressSearch.elements.searchFieldId).removeAttr("disabled");
                }
            },

            disable: {

                once: function () {
                    $("#" + AddressSearch.elements.searchFieldId).attr("disabled", "disabled");
                },

                permanent: function () {

                    // Check if the parent of the search button already has a free trial button
                    var searchButtonParent = $("#" + AddressSearch.elements.searchesRemainingId).parent();
                    var freeTrialButtonExists = searchButtonParent.find("#" + AddressSearch.elements.freeTrialBtnId).length > 0;

                    var $freeTrialBtn = $("#" + AddressSearch.elements.freeTrialBtnId);

                    if (!freeTrialButtonExists) {                       
                        // Append a clone of the free trial button to the search container
                        $freeTrialBtn.clone().insertAfter("#" + AddressSearch.elements.searchesRemainingId)
                            .addClass("col-xs-12 col-sm-6 col-md-4 col-sm-offset-3 col-md-offset-4");
                        $freeTrialBtn.parent().removeAttr("class").addClass("col-sm-12 col-md-10");
                    }

                    // Hide search field and buttons
                    $("#" + AddressSearch.elements.addressSearchContainerId).find("label, input, select, .dropdown").addClass("hidden");
                    $("#" + AddressSearch.elements.retryBtnId).addClass("hidden");                    

                    // Turn the rate limit message into an alert
                    $("." + AddressSearch.elements.rateLimitMessageClass).parent(".help-block")
                        .addClass("alert alert-danger")
                        .removeClass("help-block");

                    // Disable searching
                    AddressSearch.search.disable.once();
                    AddressSearch.search.enabled = false;

                    // Hide country selector and mode switching link
                    $("#" + AddressSearch.elements.switchModeId).hide();
                    $("#" + AddressSearch.elements.countryFieldId).siblings(".dropdown").hide();
                    $(".country-list-autocomplete-wrapper").hide();
                }
            },

            throttle: function() {
                // Turn the rate limit message into a warning
                $("." + AddressSearch.elements.rateLimitMessageClass).parent(".help-block")
                .addClass("alert alert-warning")
                .removeClass("help-block");
            },

            handleError: function (error) {
                if (error.statusText !== "abort") {
                    // Populate the error message
                    $("#" + AddressSearch.elements.errorMessageId).html(AddressSearch.messages.unknownError);
                    
                    // Log underlying error to console
                    console.error("Unknown demo error - " +
                        Utilities.escapeHtml(error.statusText) +
                        " (" + Utilities.escapeHtml(error.status) + ")");
            
                    // Show the error block and hide other content
                    AddressSearch.toggleLoading("hide");
                    $("." + AddressSearch.elements.stateClass).not(".headers").hide();
                    $("#" + AddressSearch.elements.errorPanelId).removeClass("hidden");

                    // Activate the retry button
                    $(document.body).one("click", "#" + AddressSearch.elements.retryAfterErrorBtnId, function () {
                        $("." + AddressSearch.elements.stateClass).not(".headers").show();
                        $("#" + AddressSearch.elements.errorPanelId).addClass("hidden");
                        AddressSearch.init();
                        AddressSearch.toggleLoading();
                        AddressSearch.reset();
                    });
                }
            }
        },

        picklist: {
            tabCount: 0,

            keyup: function (event) {
                var e = event || window.event;
                e = e.which || e.keyCode;
                if (e !== 38/*Up*/ && e !== 40/*Down*/) {
                    return;
                }

                var $addressList = $("#" + AddressSearch.elements.searchResultsId),
                    $addresses = $addressList.find("a"),
                    $address, addressListCoords,
                    firstAddress, lastAddress;

                // Set the tabCount based on previous and direction
                if (e === 38/*Up*/) {
                    AddressSearch.picklist.tabCount--;
                }
                else {
                    AddressSearch.picklist.tabCount++;
                }

                // Set top and bottom positions and enable wrap-around
                if (AddressSearch.picklist.tabCount < 0) {
                    AddressSearch.picklist.tabCount = $addresses.length - 1;
                    lastAddress = true;
                }
                if (AddressSearch.picklist.tabCount > $addresses.length - 1) {
                    AddressSearch.picklist.tabCount = 0;
                    firstAddress = true;
                }

                // Highlight the selected address
                $address = $addresses.eq(AddressSearch.picklist.tabCount);
                $addresses.removeClass("selected");

                if ($address.length === 0) {
                    return;
                }

                if (typeof $address.attr("information") === "undefined") {
                    $address.addClass("selected");
                }

                // Pass the search moniker to the input field (makes Enter work)
                $("#" + AddressSearch.elements.searchFieldId).attr("data-moniker", $address.attr("data-moniker"));
                $("#" + AddressSearch.elements.searchFieldId).attr("data-isrange", $address.attr("data-isrange"));

                // Scroll address into view, if required
                addressListCoords = {
                    top: $addressList.offset().top,
                    bottom: $addressList.offset().top + $addressList.outerHeight(),
                    scrollTop: $addressList.scrollTop(),
                    selectedTop: $address.offset().top,
                    selectedBottom: $address.offset().top + $address.outerHeight(),
                    scrollAmount: $address.outerHeight()
                };
                if (firstAddress) {
                    $addressList.scrollTop(0);
                }
                else if (lastAddress) {
                    $addressList.scrollTop(999);
                }
                else if (addressListCoords.selectedBottom + addressListCoords.scrollAmount > addressListCoords.bottom) {
                    $addressList.scrollTop(addressListCoords.scrollTop + addressListCoords.scrollAmount);
                }
                else if (addressListCoords.selectedTop - addressListCoords.scrollAmount - addressListCoords.top < addressListCoords.scrollTop) {
                    $addressList.scrollTop(addressListCoords.scrollTop - addressListCoords.scrollAmount);
                }

            },

            resetTabCount: function () {
                AddressSearch.picklist.tabCount = 0;
            },

            slideUp: function () {
                if ($("#" + AddressSearch.elements.searchResultsId).length > 0) {
                    $("#" + AddressSearch.elements.searchResultsId).hide();
                    $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("results refined");
                    $("#" + AddressSearch.elements.searchFieldId).removeAttr("data-moniker");
                    AddressSearch.search.searchMoniker = null;
                    AddressSearch.setSearchPrompt();
                    AddressSearch.search.lastSearch = "";
                }
            }
        },

        dataSetChanged: function () {
            AddressSearch.reset();
            // Get and set rate limit for this user
            AddressSearch.rateLimit.setInitial();
            setTimeout(function () {
                if (AddressSearch.search.mode === AddressSearch.engines.singleline) {
                    $("#" + AddressSearch.elements.searchFieldDualFirstId).focus();
                }
                else if (AddressSearch.search.mode === AddressSearch.engines.verification) {
                    $("#address-layout input:first").focus();
                }
                else {
                    $("#" + AddressSearch.elements.searchFieldId).focus();
                }
                // Hide/show location specific searching checkbox if USA selected/unselected and feature is enabled
                if ($("#" + AddressSearch.elements.countryFieldId).val() === "USA" && AddressSearch.settings.showLocationBasedSearching) {
                    $("#" + AddressSearch.elements.locationBasedSearchingContainerId).removeClass("hidden");
                } else {
                    $("#" + AddressSearch.elements.locationBasedSearchingContainerId).addClass("hidden");
                }
            }, 0);
        },

        reset: function () {
            $("#" + AddressSearch.elements.searchResultsId).html("").hide();
            $("#" + AddressSearch.elements.searchFieldId).val("");
            $("#" + AddressSearch.elements.searchFieldDualFirstId).val("");
            $("#" + AddressSearch.elements.searchFieldDualSecondId).val("");
            $("#" + AddressSearch.elements.searchFieldWrapperId).removeClass("results refining refined");
            $("#" + AddressSearch.elements.searchFieldId).removeAttr("data-moniker");
            AddressSearch.setSearchPrompt();
            AddressSearch.setSearchOptions();
        }

    };

    return AddressSearch;
});